import { components, OptionProps } from 'react-select';
import styled from 'styled-components';

import { IconCheck } from '../../../common/icons/cdl/Check';
import { theme } from '../../../common/ui/theme';
import { Text } from '../../Text/Text';

const StyledOptionContainer = styled.div`
    display: grid;
    grid-template-columns: ${theme.space[24]} auto;
    gap: ${theme.space[4]};
    align-items: center;
    min-height: 32px;
    font-weight: ${theme.fontWeights[500]};
    vertical-align: center;
    padding: 0 0 0 ${theme.space[8]};
    color: ${theme.colors.foreground.default};
    border-radius: ${theme.radii[4]};
`;

export const CustomOption = ({ children, ...rest }: OptionProps) => {
    const backgroundColor = rest.isFocused ? theme.colors.accent.background : theme.colors.background.default;

    return (
        <components.Option {...rest}>
            <StyledOptionContainer style={{ backgroundColor }}>
                <div>
                    {rest.isSelected ? (
                        <IconCheck height={16} width={16} style={{ color: theme.colors.accent.foreground }} />
                    ) : null}
                </div>

                <Text
                    variant="small"
                    color={rest.isSelected ? 'accent.foreground' : 'foreground.default'}
                    style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                >
                    {children}
                </Text>
            </StyledOptionContainer>
        </components.Option>
    );
};
